// Status pill of a WhatsApp intake, shared by the queue card and the detail.
export const STATUS_PILL = {
  accepted: { label: 'Aceptado', tone: 'ok' },
  pending: { label: 'Pendiente', tone: 'warn' },
  rejected: { label: 'Rechazado', tone: 'err' },
};
